<template>
	<div class="card">
		<header class="card-header language-list">
			<h3 class="card-title">Recommended Articles</h3>
			<lang-selector></lang-selector>
		</header>
		<div class="card-body">
			<h4 class="card-subtitle">Select the 4 recommended articles</h4>
			<div class="flex box">
				<div class="form-group six">
					<label>Recommended Article 1</label>
					<select3 :value.sync="metaSeoRecommendedArticles.recommendedArticles[clickedLang][0].id" :data="metaSeoRecommendedArticles.allArticles[clickedLang]" :config="selectConfig"></select3>
				</div>
				<div class="form-group six">
					<label>Recommended Article 2</label>
					<select3 :value.sync="metaSeoRecommendedArticles.recommendedArticles[clickedLang][1].id" :data="metaSeoRecommendedArticles.allArticles[clickedLang]" :config="selectConfig"></select3>
				</div>
				<div class="form-group six">
					<label>Recommended Article 3</label>
					<select3 :value.sync="metaSeoRecommendedArticles.recommendedArticles[clickedLang][2].id" :data="metaSeoRecommendedArticles.allArticles[clickedLang]" :config="selectConfig"></select3>
				</div>
				<div class="form-group six">
					<label>Recommended Article 4</label>
					<select3 :value.sync="metaSeoRecommendedArticles.recommendedArticles[clickedLang][3].id" :data="metaSeoRecommendedArticles.allArticles[clickedLang]" :config="selectConfig"></select3>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {eventBus} from "../../app";

	export default {
		props: {
			metaSeoRecommendedArticles: {
				required: true
			}
		},
		data() {
			return {
				selectConfig: {
					keyName: 'id',
					valueName: 'title'
				},
				clickedLang: this.$defaultLanguage.locale
			}
		},
		created() {
			let vm = this;
			// When setActiveStatus method ran, change selected data in form fields
			/* From LangSelector */
			eventBus.$on('setActiveStatus', function (clickedLang) {
				vm.clickedLang = clickedLang;
			});
		}
	}
</script>

<style scoped>

</style>
